import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FeatureService } from 'src/app/shared/preview-feature/preview-feature.service';

import { AlertService } from 'src/app/services/alert.service';
import { CommandService } from 'src/app/services/task/command/command.service';
import { SystemEvaluatorService } from 'src/app/services/task/system-evaluator/system-evaluator.service';
import { ITaskCommandWrapper, TaskExecutionTime } from '../task/task.state.models';
import { TaskService } from 'src/app/services/task/task.service';
import { IMemberSessionManager } from './member.models';
import { SessionStatus } from 'src/app/models/member';
import { CommandLazyDataService } from 'src/app/services/task/command/command-lazy-data.service';
import { ICommandCancelConfig } from 'src/app/services/task/command/command.models';

@Injectable({
    providedIn: 'root'
})
export class MemberTaskService extends TaskService {

    constructor(
        systemEvaluatorService: SystemEvaluatorService,
        commandService: CommandService,
        featureService: FeatureService,
        alertService: AlertService,
        router: Router,
        commandLazyDataService: CommandLazyDataService
    ) {
        super(
            systemEvaluatorService,
            commandService,
            featureService,
            alertService,
            router,
            commandLazyDataService
        );
    }

    async afterMarkedAsCanceled(cmd: ITaskCommandWrapper, cancelConfig?: ICommandCancelConfig) {
        const executionTime: TaskExecutionTime = cmd.task.executionTime || TaskExecutionTime.Start;
        if (executionTime === TaskExecutionTime.Start) {
            // send user to member search
            await this.router.navigate(['/search']);
        } else if (executionTime === TaskExecutionTime.End) {
            (this.host as unknown as IMemberSessionManager).setSessionStatus(SessionStatus.Open);
        }
    }
}
